<template>
  <TutorialPostContainer>
    <template #preventPageTitle>
      {{ t('tutorial.title') || '' }}
    </template>

    <template #postTitle>
      {{ post?.title || '' }}
    </template>

    <template #content>
      <p v-if="postStatus === 'success' && !post">
        {{ t('tutorial.translationUnavailable') }}
      </p>
      <div 
        v-else-if="post?.content"
        v-html="post.content"
      />
    </template>

    <template #subscr>
      <Subscribe />
    </template>
  </TutorialPostContainer>
</template>

<script setup lang="ts">
import { resolveLocalizedPost } from '~/utils/wordpress';

const route = useRoute();
const { locale, t } = useI18n();
const localePath = useLocalePath();

function stripAdminLinksFromHtml(html, siteOrigin = (typeof window !== 'undefined' ? window.location.origin : 'https://wp.0detect.com')) {
  if (!html) return html;
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  doc.querySelectorAll('a[href]').forEach(a => {
    const rawHref = a.getAttribute('href') || '';
    let pathname = rawHref;

    try {
      pathname = new URL(rawHref, siteOrigin).pathname;
    } catch { /* игнорируем кривые href */ }

    if (pathname.includes('/wp-admin/')) {
      const frag = doc.createDocumentFragment();
      while (a.firstChild) frag.appendChild(a.firstChild);
      a.replaceWith(frag);
    }
  });

  return doc.body.innerHTML;
}

function preparePost(post: Record<any, any> | null) {
  if (!post) {
    return null;
  }

  post.content = stripAdminLinksFromHtml(post.content, 'https://wp.0detect.com');
  return post;
}

const getPost = async (): Promise<Record<any, any> | null> => {
  const post = await resolveLocalizedPost({
    id: String(route.params._id),
    locale: locale.value,
    localizedPath: id => localePath(`/tutorial/${id}`),
    responseFormat: 'custom',
    detailEndpoint: 'wp/v2/tutorial',
    listEndpoint: 'custom/v1/tutorial',
  });

  return preparePost(post);
};

const { data: post, status: postStatus } = useAsyncData(
  'tutorial-post',
  () => getPost(),
  {
    watch: [locale, () => route.params._id],
    server: true,
    lazy: false,
    default: () => null,
  },
);
</script>
